module.exports = __webpack_public_path__ + "static/media/product-image.ff247112.jpg";